import QUERYKEYS from '../../../constants/queryKeys';
import type { TQueryModel } from '../../../utils/hookUtils';
import type { TVendorCodesInternetHomeWarranty } from './../../../models/vendor/VendorCodeModels';
import { getVendorCodeInternetHomeWarranty } from './../../../services/VendorCodesService';
import { useQuery } from 'react-query';

function useVendorCodeInternetHomeWarranty(
  vendorCodeId: string,
): TQueryModel<TVendorCodesInternetHomeWarranty> {
  const { isLoading, isError, data } = useQuery(
    [QUERYKEYS.VENDOR_CODES_INTERNET_HOME_WARRANTY, vendorCodeId],
    () => getVendorCodeInternetHomeWarranty(vendorCodeId),
  );

  return {
    data,
    isError,
    isLoading,
  };
}

export default useVendorCodeInternetHomeWarranty;
